import React from 'react'
import axios from 'lib/axios'

async function updateEnableAutomatedQuestionnaires(url, data, successCallback) {
  return await axios
    .post(url, data)
    .then((response) => successCallback(response.data.enable_automated_questionnaires))
    .catch((error) => alert(error))
}

function EnableAutomatedQuestionnaires({
  organization,
  isAutomatedQuestionnaireEnabled,
  setIsAutomatedQuestionnaireEnabled,
}) {
  function handleChangeValue(value) {
    const url = `/super/organizations/${organization.id}/questionnaires/enable_automated_questionnaires`
    const payload = { enable_automated_questionnaires: value ? 1 : 0 }

    updateEnableAutomatedQuestionnaires(url, payload, setIsAutomatedQuestionnaireEnabled)
  }

  return (
    <>
      <div className="row">
        <div className="col-sm-4">Enable Automated Questionnaires?</div>
        <div className="col-sm-4">
          <select
            defaultValue={isAutomatedQuestionnaireEnabled ? '1' : '0'}
            onChange={(e) => handleChangeValue(parseInt(e.target.value) == 1)}
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>
    </>
  )
}

export default EnableAutomatedQuestionnaires
